<div id="content" class="main-content">
     <div class="container">
        <div class="col-12 pl-0">
           <div class="crumbs breadcrumbs-style-2">
              <ul class="breadcrumb">
                 <li class="mt-3"><a class="pointer" routerLink="/dashboard"><i class="flaticon-home-fill"></i></a></li>
                 <li class="mt-3"><a class="pointer" routerLink="/absence">Absences</a></li>
                 <li class="active mt-3 current_arian"><a href="javascript:void(0);" class="current_arian">Demande d'absence</a></li>
              </ul>
           </div>
        </div>
       <div class="page-header">
          <div class="page-title mt-3 row col-lg-12 col-md-12">
             <h2 style="color:black">Demande d'absence</h2>
             <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger" 
               id="profil_added" role="alert" style="z-index: 9;position: absolute;display: none;right: 0; width: fit-content;
               position: absolute;background-image: linear-gradient(135deg,#30648fed 0,#009de6c4 100%) !important;"> 
               <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
               <strong>La demande d'absence</strong> a été ajoutée avec succès.
            </div>
            <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger" 
               id="profil_not_added" role="alert" style="z-index: 100;position: absolute;display: none;right: 0; width: fit-content;
               position: absolute;background-image: linear-gradient(135deg,#8f3030ed 0,#e60000c4 100%) !important;"> 
               <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
               <strong>La demande d'absence a échoué</strong>Veuillez réessayer plus tard
            </div>
          </div>
       </div>
       <form class="form-login" [formGroup]="absenceForm"  novalidate>
          <div class="row layout-spacing">
             <!-- COLUMN OF FORMULAIRE -->
             <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 layout-spacing">
                <div class="statbox widget box box-shadow">
                   <div class="widget-content widget-content-area" style="border-top-right-radius: 6px;
                      border-top-left-radius: 6px;">
                      <div *ngIf="sendRequestloading" class="cp-spinner cp-bubble" style="position: absolute;z-index: 9;margin: auto;display: block;margin-left: 42%;margin-top: 10%;">
                     </div>
                      <div class="row form-group mb-3">
                        <div class="row col-lg-12 col-md-12 col-sm-12 col-xs-12">
                           <label for="label" class="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-form-label col-form-label-sm">
                             Type d'absence <span style="color: red;"><b>*</b> </span>  
                           </label>
                           <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 pr-0 pl-0" style="display: flex; justify-content: space-around;">
                             <div class="form-check form-check-inline">
                               <input class="form-check-input" type="radio" id="congeSansSolde" name="type" value="Congé sans solde" formControlName="type">
                               <label class="form-check-label" for="conge">Congé sans solde</label>
                             </div>
                             <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" id="congePaye" name="type" value="Congé payé" formControlName="type">
                              <label class="form-check-label" for="conge">Congé payé</label>
                            </div>
                             <div class="form-check form-check-inline">
                               <input class="form-check-input" type="radio" id="maladie" name="type" value="Maladie" formControlName="type">
                               <label class="form-check-label" for="maladie">Maladie</label>
                             </div>
                             <div class="form-check form-check-inline">
                               <input class="form-check-input" type="radio" id="autre" name="type" value="Autre" formControlName="type">
                               <label class="form-check-label" for="autre">Autre</label>
                             </div>
                           </div>
                         </div>
                      </div>
                      
                      <div class="row form-group mb-3 mt-1">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                           <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                              <input type="date" class="mdl-textfield__input " id="startDate" name="startDate" formControlName="startDate">
                              <label class="mdl-textfield__label" for="startDate">Date de début de l’absence <span style="color: red;"><b>*</b></span></label>
                           </div>
                           <div *ngIf="absenceForm.get('startDate')?.errors && absenceForm.get('startDate')?.touched" class="text-danger">
                              <div *ngIf="absenceForm.get('startDate')?.errors?.required">
                                  La date de début de l'absence est requise.
                              </div>
                              <div *ngIf="absenceForm.get('startDate')?.errors?.invalidStartDate">
                                  La date de début de l'absence doit être aujourd'hui ou plus tard.
                              </div>
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                           <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                              <input type="date" class="mdl-textfield__input " id="endDate" name="endDate" formControlName="endDate">
                              <label class="mdl-textfield__label" for="endDate">Date de fin de l’absence <span style="color: red;"><b>*</b></span></label>
                           </div>
                           <div *ngIf="absenceForm.get('endDate')?.errors && absenceForm.get('endDate')?.touched" class="text-danger">
                              <div *ngIf="absenceForm.get('endDate')?.errors?.required">
                                  La date de fin de l'absence est requise.
                              </div>
                              <div *ngIf="absenceForm.get('endDate')?.errors?.invalidEndDate">
                                  La date de fin de l'absence doit être après la date de début.
                              </div>
                              <div *ngIf="absenceForm.get('endDate')?.errors?.invalidStartDate">
                                  La date de fin de l'absence doit être aujourd'hui ou plus tard.
                              </div>
                          </div>
                        </div>
                     </div>
                     <div class="row form-group mb-3 mt-1">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                           <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                              <textarea type="text" class="mdl-textfield__input" id="motif" name="motif" formControlName="motif" style="height: 100px;"></textarea>
                              <label class="mdl-textfield__label" for="motif"> Motif d'absence</label>
                           </div>
                        </div>
                     </div>
                     <div class="row  form-group mb-3 mt-4">
                        <div class="custom-file-container w-100" data-upload-id="myFirstImage">
                           <p class="mb-0"><i class="flaticon-picture text-default mr-2" style="background-color: unset;"></i>Joindre des photos</p>
                           <label class="custom-file-container__custom-file" >
                               <input type="file" class="custom-file-container__custom-file__custom-file-input upload__inputfile" accept="image/*" multiple=""
                                   data-max_length="20" (change)="addPic($event)">
                               <input type="hidden" name="MAX_FILE_SIZE" value="10485760" />
                               <span class="custom-file-container__custom-file__custom-file-control"></span>
                           </label>
                           <div class="upload__img-wrap"></div>
                       </div>
                     </div>
                    </div>
                </div>
             </div>
             <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 layout-spacing">
                <div class="l-a-load-more pt-2 actions_buttons d-flex justify-content-center">
                   <button type="reset" class="btn progress-button btn-rounded mb-2 pr-5 pl-5 mr-2" style="background-color: #bac5ed;" routerLink="/absence">
                      Annuler
                   </button>
                   <button id="loading-circle-notification" class="btn btn-gradient-success btn-rounded mb-2 mr-2 pr-5 pl-5"
                   (click)="saveAbsence()" [disabled]="absenceForm.invalid">Soumettre</button>
                   </div>
             </div>
          </div>
       </form>
     </div>
  </div>